import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1402Component } from './kymw1402.component';
import { GetKomaPrintDataService } from './api-services/get-koma-print-data.service';
import { GetPrintPageDataService } from './api-services/get-print-page-data.service';


/**
 * 誌面印刷画面 モジュール設定クラス
 *
 * @export KYMW1402Module
 * @class KYMW1402Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [
    KYMW1402Component,
  ],
  providers: [
    GetKomaPrintDataService,
    GetPrintPageDataService,
  ],
})
export class KYMW1402Module {
}
